<div>
<nx-pageTitle-box
  [label]="'Rechnungsstellung'" 
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'/settings'"
  [icon]="'icon-invoice'"
  [iconToolTip]="'Rechnungsstellung'">
</nx-pageTitle-box>


  <p-tabView [scrollable]="true">
    <p-tabPanel header="Lizenzen">
      <app-billing-licence-view></app-billing-licence-view>
    </p-tabPanel>
    <p-tabPanel header="Rechnungsempfang">
      <app-billing-invoice-receiver-view></app-billing-invoice-receiver-view>
    </p-tabPanel>
    <p-tabPanel header="Zahlung">
      <app-billing-payment-method-view></app-billing-payment-method-view>
    </p-tabPanel>
    <p-tabPanel header="Rechnungen">
      <app-billing-invoice-list></app-billing-invoice-list>
    </p-tabPanel>

  </p-tabView>  

